module.exports = __webpack_public_path__ + "static/media/tauchsieder_schema.063fe3b1.jpg";